/**
 * Vuex getters built from `@/shared/config/flag-getters.json`: each returns one flag exactly as
 * `isFeatureEnabled` reads it, overrides included.
 */
export const buildFlagGetters = (entries) => Object.fromEntries(
  entries.map(({ name, flag }) => [name, (_, getters) => getters.isFeatureEnabled(flag)]),
)
